"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const action_1 = require("./action");
var ProgressActionType;
(function (ProgressActionType) {
    ProgressActionType["START_ACTION"] = "@Progress/START_ACTION";
    ProgressActionType["END_ACTION"] = "@Progress/END_ACTION";
    ProgressActionType["FAIL_ACTION"] = "@Progress/FAIL_ACTION";
    ProgressActionType["RESET_ACTION"] = "@Progress/RESET_ACTION";
})(ProgressActionType = exports.ProgressActionType || (exports.ProgressActionType = {}));
exports.ProgressActions = {
    startAction: (type) => action_1.createAction(ProgressActionType.START_ACTION, { type }),
    endAction: (type) => action_1.createAction(ProgressActionType.END_ACTION, { type }),
    failAction: (type, error) => action_1.createAction(ProgressActionType.FAIL_ACTION, { type, error }),
    resetAction: (type) => action_1.createAction(ProgressActionType.RESET_ACTION, { type }),
};
